export const serviceInitialState = {
  loading: false,
  services: [],
  error: null
}